import { IcWebRelay } from '@assets/icons/32x32';
import { chakra } from '@chakra-ui/react';
import { colors } from '@theme/foundations/colors';
import { useEffect, useRef, useState } from 'react';
import { useIntl } from 'react-intl';

import { HealthStatusEnum } from '@/types/sensor/sensors';

import Gate from '../../schematic/Gate';
import SquareInfo from '../../schematic/SquareInfo';
import { commonHolopticsI18nPath } from './HolopticsSchematic';

const Text = chakra('text');

export default function HolopticsCoffretSchematic() {
  const { formatMessage } = useIntl();
  const textRef = useRef<SVGTextElement | null>(null);
  const [bbox, setBbox] = useState<DOMRect | null>(null);

  useEffect(() => {
    if (textRef.current) {
      const box = textRef.current.getBBox();
      setBbox(box);
    }
  }, []);

  return (
    <svg width="1219" height="519" viewBox="0 0 1219 519" fill="none">
      {bbox && (
        <rect
          x={bbox.x - 8}
          y={bbox.y - 3}
          width={bbox.width + 16}
          height={bbox.height + 7}
          fill={colors.neutral['600'].value}
        />
      )}
      <Text
        ref={textRef}
        y="190"
        x="704"
        textAnchor="end"
        fontWeight="medium"
        fill={colors.neutral['300'].value}
        style={{ textTransform: 'uppercase' }}
      >
        {formatMessage({ id: `${commonHolopticsI18nPath}.webRelayCabinet` })}
      </Text>
      <rect width="188" height="140" transform="translate(524 199)" fill={colors.neutral['600'].value} />
      <rect width="124" height="78" transform="translate(564 230)" fill={colors.neutral['700'].value} />
      <path
        d="M623.25 269H661.75" //TODO isConnectedWebrelay "M623.25 269H660" when open
        stroke={colors.neutralBlue['800'].value}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="bevel"
        strokeDasharray="1,3"
      />

      {/* Web relay */}
      <SquareInfo
        x={580}
        y={246}
        name={formatMessage({ id: `${commonHolopticsI18nPath}.webrelay` })}
        isConnected
        isPresent
        icon={IcWebRelay}
        status={HealthStatusEnum.HEALTHY}
      />
      <Gate x={649} y={252.5} isConnected />

      {/* Other links */}
      <path
        d="M55.5 39H515C528.255 39 539 49.7452 539 63V245C539 258.255 549.745 269 563 269H576.5"
        stroke={colors.neutral['200'].value}
        strokeWidth="2"
        strokeLinejoin="bevel"
      />
      <path
        d="M55.5 39H515C528.255 39 539 49.7452 539 63V200C539 213.255 549.745 224 563 224H642C655.255 224 666 234.745 666 248V253"
        stroke={colors.neutral['200'].value}
        strokeWidth="2"
        strokeLinejoin="bevel"
      />
    </svg>
  );
}
